/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * Payout
 * Payout application
 * OpenAPI spec version: 1.0
 */

/**
 * Enum representing supported banks.
 */
export enum UniteTypeBank {
    BANK_UNSPECIFIED = 'BANK_UNSPECIFIED',
    BANK_GAZPROMBANK = 'BANK_GAZPROMBANK',
    BANK_KORONAPAY_CREDIT_UNION_PAYMENT_CENTER = 'BANK_KORONAPAY_CREDIT_UNION_PAYMENT_CENTER',
    BANK_BANK_SINARA_SKB_BANK = 'BANK_BANK_SINARA_SKB_BANK',
    BANK_TINKOFF = 'BANK_TINKOFF',
    BANK_VTB = 'BANK_VTB',
    BANK_AKBARS = 'BANK_AKBARS',
    BANK_RAIFFEISEN = 'BANK_RAIFFEISEN',
    BANK_ALFA = 'BANK_ALFA',
    BANK_QIWI = 'BANK_QIWI',
    BANK_PROMSVYAZBANK = 'BANK_PROMSVYAZBANK',
    BANK_RNCB = 'BANK_RNCB',
    BANK_ROSBANK = 'BANK_ROSBANK',
    BANK_SOVCOMBANK = 'BANK_SOVCOMBANK',
    BANK_RUSSIANSTANDARD = 'BANK_RUSSIANSTANDARD',
    BANK_OTKRITIE = 'BANK_OTKRITIE',
    BANK_POCHTABANK = 'BANK_POCHTABANK',
    BANK_MTSBANK = 'BANK_MTSBANK',
    BANK_OTPBANK = 'BANK_OTPBANK',
    BANK_AGRICULTURAL = 'BANK_AGRICULTURAL',
    BANK_YOOMONEY = 'BANK_YOOMONEY',
    BANK_HOMECREDIT = 'BANK_HOMECREDIT',
    BANK_MKBBANK = 'BANK_MKBBANK',
    BANK_URALSIB = 'BANK_URALSIB',
    BANK_CREDITEUROPEBANK = 'BANK_CREDITEUROPEBANK',
    BANK_AVANGARD = 'BANK_AVANGARD',
    BANK_BANKSAINTP = 'BANK_BANKSAINTP',
    BANK_UNICREDIT = 'BANK_UNICREDIT',
    BANK_UBRD = 'BANK_UBRD',
    BANK_RENCREDIT = 'BANK_RENCREDIT',
    BANK_PROMSVAZBAK = 'BANK_PROMSVAZBAK',
    BANK_TRANSCAPITALBANK = 'BANK_TRANSCAPITALBANK',
    BANK_ZAPSIBKOMBANK = 'BANK_ZAPSIBKOMBANK',
    BANK_SEVERNYMORSKOYPUT = 'BANK_SEVERNYMORSKOYPUT',
    BANK_GENBANK = 'BANK_GENBANK',
    BANK_FINAMINVESTMENTBANK = 'BANK_FINAMINVESTMENTBANK',
    BANK_BCSBANK = 'BANK_BCSBANK',
    BANK_UNISTREAM_BANK = 'BANK_UNISTREAM_BANK',
    BANK_GAZENERGOBANK = 'BANK_GAZENERGOBANK',
    BANK_EXPOBANK = 'BANK_EXPOBANK',
    BANK_ZENITBANK = 'BANK_ZENITBANK',
    BANK_METALLINVESTBANK = 'BANK_METALLINVESTBANK',
    BANK_ABSOLUT = 'BANK_ABSOLUT',
    BANK_BANK_VBRR = 'BANK_BANK_VBRR',
    BANK_KUBANKREDIT = 'BANK_KUBANKREDIT',
    BANK_NSKBL = 'BANK_NSKBL',
    BANK_BLANC_BANK = 'BANK_BLANC_BANK',
    BANK_WEBMONEY_BANK_CCB = 'BANK_WEBMONEY_BANK_CCB',
    BANK_BANK_YOSHKAR_OLA = 'BANK_BANK_YOSHKAR_OLA',
    BANK_CB_KHLYNOV = 'BANK_CB_KHLYNOV',
    BANK_VK_PAY_MONEY_MAIL_RU = 'BANK_VK_PAY_MONEY_MAIL_RU',
    BANK_VLADBUSINESSBANK = 'BANK_VLADBUSINESSBANK',
    BANK_CENTR_INVEST = 'BANK_CENTR_INVEST',
    BANK_MONETA = 'BANK_MONETA',
    BANK_NOKSSBANK = 'BANK_NOKSSBANK',
    BANK_CREDIT_URAL_BANK = 'BANK_CREDIT_URAL_BANK',
    BANK_TOCHKA_BANK_OTKRITIE_FINANCIAL_CORPORATION = 'BANK_TOCHKA_BANK_OTKRITIE_FINANCIAL_CORPORATION',
    BANK_ZEMSKY_BANK = 'BANK_ZEMSKY_BANK',
    BANK_NC_BANK = 'BANK_NC_BANK',
    BANK_SDM_BANK = 'BANK_SDM_BANK',
    BANK_DATABANK = 'BANK_DATABANK',
    BANK_NS_BANK = 'BANK_NS_BANK',
    BANK_BRATSKY_NARODNY_BANK = 'BANK_BRATSKY_NARODNY_BANK',
    BANK_INGOSSTRAKH_BANK_BANK_SOYUZ = 'BANK_INGOSSTRAKH_BANK_BANK_SOYUZ',
    BANK_ALMAZERGIENBANK = 'BANK_ALMAZERGIENBANK',
    BANK_FORSHTADT = 'BANK_FORSHTADT',
    BANK_BANK_DOM_RF = 'BANK_BANK_DOM_RF',
    BANK_FAR_EASTERN_BANK = 'BANK_FAR_EASTERN_BANK',
    BANK_ROSDORBANK = 'BANK_ROSDORBANK',
    BANK_ELPLAT = 'BANK_ELPLAT',
    BANK_BANK_PSCB = 'BANK_BANK_PSCB',
    BANK_SCBP_PRIMSOTSBANK = 'BANK_SCBP_PRIMSOTSBANK',
    BANK_KB_KOLTSO_URALA = 'BANK_KB_KOLTSO_URALA',
    BANK_BANK_EKATERINBURG = 'BANK_BANK_EKATERINBURG',
    BANK_JSC_BANK_SNGB = 'BANK_JSC_BANK_SNGB',
    BANK_BYSTROBANK = 'BANK_BYSTROBANK',
    BANK_COALMETBANK = 'BANK_COALMETBANK',
    BANK_CHELYABINVESTBANK = 'BANK_CHELYABINVESTBANK',
    BANK_BANK_ROSSIYA = 'BANK_BANK_ROSSIYA',
    BANK_URALFINANCE = 'BANK_URALFINANCE',
    BANK_COMMERCIAL_BANK_ROSTFINANCE = 'BANK_COMMERCIAL_BANK_ROSTFINANCE',
    BANK_CB_MODULBANK = 'BANK_CB_MODULBANK',
    BANK_ELECSNET = 'BANK_ELECSNET',
    BANK_BANK_AGROROS = 'BANK_BANK_AGROROS',
    BANK_CB_POIDEM = 'BANK_CB_POIDEM',
    BANK_SBI_BANK = 'BANK_SBI_BANK',
    BANK_CHELINDBANK = 'BANK_CHELINDBANK',
    BANK_AKIBANK = 'BANK_AKIBANK',
    BANK_ASIAN_PACIFIC_BANK = 'BANK_ASIAN_PACIFIC_BANK',
    BANK_NCO_ERP = 'BANK_NCO_ERP',
    BANK_CB_MOSKOMMERTSBANK = 'BANK_CB_MOSKOMMERTSBANK',
    BANK_SBERBANK = 'BANK_SBERBANK',
    BANK_GARANT_INVEST_BANK = 'BANK_GARANT_INVEST_BANK',
    BANK_ALEF_BANK = 'BANK_ALEF_BANK',
    BANK_NICO_BANK = 'BANK_NICO_BANK',
    BANK_PROBANK = 'BANK_PROBANK',
    BANK_CB_AGROPROMCREDIT = 'BANK_CB_AGROPROMCREDIT',
    BANK_CB_SOLIDARNOST = 'BANK_CB_SOLIDARNOST',
    BANK_IC_BANK = 'BANK_IC_BANK',
    BANK_BANK_ORENBURG = 'BANK_BANK_ORENBURG',
    BANK_GORBANK = 'BANK_GORBANK',
    BANK_BANK_SARATOV = 'BANK_BANK_SARATOV',
    BANK_KHAKAS_MUNICIPAL_BANK = 'BANK_KHAKAS_MUNICIPAL_BANK',
    BANK_CITIBANK = 'BANK_CITIBANK',
    BANK_CB_ARESBANK = 'BANK_CB_ARESBANK',
    BANK_AVTOGRADBANK = 'BANK_AVTOGRADBANK',
    BANK_TOCHKA_QIWI = 'BANK_TOCHKA_QIWI',
    BANK_BBR_BANK = 'BANK_BBR_BANK',
    BANK_NBD_BANK = 'BANK_NBD_BANK',
    BANK_BANK_AKCEPT = 'BANK_BANK_AKCEPT',
    BANK_METKOMBANK = 'BANK_METKOMBANK',
    BANK_FIRST_DORTRANSBANK = 'BANK_FIRST_DORTRANSBANK',
    BANK_TOYOTA_BANK = 'BANK_TOYOTA_BANK',
    BANK_CB_ENERGOTRANSBANK = 'BANK_CB_ENERGOTRANSBANK',
    BANK_MB_BANK = 'BANK_MB_BANK',
    BANK_URALPROMBANK = 'BANK_URALPROMBANK',
    BANK_BANK_131 = 'BANK_BANK_131',
    BANK_TIMER_BANK = 'BANK_TIMER_BANK',
    BANK_KOSHELEV_BANK = 'BANK_KOSHELEV_BANK',
    BANK_SAROVBUSINESSBANK = 'BANK_SAROVBUSINESSBANK',
    BANK_SINKO_BANK = 'BANK_SINKO_BANK',
    BANK_GUTA_BANK = 'BANK_GUTA_BANK',
    BANK_YANDEXBANK = 'BANK_YANDEXBANK',
    BANK_URALFD = 'BANK_URALFD',
    BANK_TOGLIATTIKHIMBANK = 'BANK_TOGLIATTIKHIMBANK',
    BANK_BANK_VENETS = 'BANK_BANK_VENETS',
    BANK_BANK_AVERS = 'BANK_BANK_AVERS',
    BANK_BANK_ITURUP = 'BANK_BANK_ITURUP',
    BANK_ENERGOBANK = 'BANK_ENERGOBANK',
    BANK_YUG_INVESTBANK = 'BANK_YUG_INVESTBANK',
    BANK_LOCKO_BANK = 'BANK_LOCKO_BANK',
    BANK_BANK_SNEZHINSKIY = 'BANK_BANK_SNEZHINSKIY',
    BANK_KEB_HNB_RUS = 'BANK_KEB_HNB_RUS',
    BANK_RUSSIAN_UNIVERSAL_BANK = 'BANK_RUSSIAN_UNIVERSAL_BANK',
    BANK_SIBSOCBANK = 'BANK_SIBSOCBANK',
    BANK_EVROFINANCE_MOSNARBANK = 'BANK_EVROFINANCE_MOSNARBANK',
    BANK_WORLD_OF_PRIVILEGE_BANK_MP_BANK_SKS_BANK = 'BANK_WORLD_OF_PRIVILEGE_BANK_MP_BANK_SKS_BANK',
    BANK_BANCA_INTESA = 'BANK_BANCA_INTESA',
    BANK_MARITIME_BANK = 'BANK_MARITIME_BANK',
    BANK_DEVELOPMENT_CAPITAL_BANK = 'BANK_DEVELOPMENT_CAPITAL_BANK',
    BANK_TAVRICHESKY_BANK = 'BANK_TAVRICHESKY_BANK',
    BANK_FINBANK = 'BANK_FINBANK',
    BANK_JSCB_TENDER_BANK = 'BANK_JSCB_TENDER_BANK',
    BANK_MOSCOMBANK = 'BANK_MOSCOMBANK',
    BANK_NOVIKOMBANK = 'BANK_NOVIKOMBANK',
    BANK_KVANT_MOBILE_BANK = 'BANK_KVANT_MOBILE_BANK',
    BANK_VOZROZHDENIE_BRANCH_BM_BANK = 'BANK_VOZROZHDENIE_BRANCH_BM_BANK',
    BANK_KUBAN_TRADE_BANK = 'BANK_KUBAN_TRADE_BANK',
    BANK_AVTOTORGBANK = 'BANK_AVTOTORGBANK',
    BANK_B_NK_UNITED_CAPITAL = 'BANK_B_NK_UNITED_CAPITAL',
    BANK_LLC_CB_GT_BANK = 'BANK_LLC_CB_GT_BANK',
    BANK_JSCB_NRBANK = 'BANK_JSCB_NRBANK',
    BANK_NATSINVESTPROMBANK = 'BANK_NATSINVESTPROMBANK',
    BANK_BANK_RESO_CREDIT = 'BANK_BANK_RESO_CREDIT',
    BANK_TATSOTSBANK = 'BANK_TATSOTSBANK',
    BANK_BANK_OF_KAZAN = 'BANK_BANK_OF_KAZAN',
    BANK_BANK_IBA_MOSCOW = 'BANK_BANK_IBA_MOSCOW',
    BANK_CB_STROYLESBANK = 'BANK_CB_STROYLESBANK',
    BANK_RUSNARBANK = 'BANK_RUSNARBANK',
    BANK_KUZNETSKBUSINESSBANK = 'BANK_KUZNETSKBUSINESSBANK',
    BANK_INBANK = 'BANK_INBANK',
    BANK_TRANSSTROIBANK = 'BANK_TRANSSTROIBANK',
    BANK_ECONOMBANK = 'BANK_ECONOMBANK',
    BANK_ISBANK = 'BANK_ISBANK',
    BANK_JSCB_SLAVIA = 'BANK_JSCB_SLAVIA',
    BANK_BANK_KREMLYOVSKIY = 'BANK_BANK_KREMLYOVSKIY',
    BANK_NORVIK_BANK = 'BANK_NORVIK_BANK',
    BANK_INTERNATIONAL_FINANCIAL_CLUB = 'BANK_INTERNATIONAL_FINANCIAL_CLUB',
    BANK_AMERICAN_EXPRESS_BANK = 'BANK_AMERICAN_EXPRESS_BANK',
    BANK_BANK_ZARECHYE = 'BANK_BANK_ZARECHYE',
    BANK_TOMSKPROMSTROYBANK = 'BANK_TOMSKPROMSTROYBANK',
    BANK_DEUTSCHE_BANK = 'BANK_DEUTSCHE_BANK',
    BANK_SNB = 'BANK_SNB',
    BANK_BALTINVESTBANK = 'BANK_BALTINVESTBANK',
    BANK_BANK_ALEKSANDROVSKY = 'BANK_BANK_ALEKSANDROVSKY',
    BANK_CROCUS_BANK = 'BANK_CROCUS_BANK',
    BANK_J_T_BANK_A_O = 'BANK_J_T_BANK_A_O',
    BANK_VUZ_BANK = 'BANK_VUZ_BANK',
    BANK_BANK_FINSERVICE = 'BANK_BANK_FINSERVICE',
    BANK_FORA_BANK = 'BANK_FORA_BANK',
    BANK_CCB_RUSSIA = 'BANK_CCB_RUSSIA',
    BANK_BANK_SGB = 'BANK_BANK_SGB',
    BANK_MOSOBLBANK = 'BANK_MOSOBLBANK',
    BANK_NOVOBANK = 'BANK_NOVOBANK',
    BANK_SOCIUM_BANK = 'BANK_SOCIUM_BANK',
    BANK_BELGORODSOCBANK = 'BANK_BELGORODSOCBANK',
    BANK_PJSCB_PRIMORYE = 'BANK_PJSCB_PRIMORYE',
    BANK_CFB_LLC = 'BANK_CFB_LLC',
    BANK_PRIO_VNESHTORGBANK = 'BANK_PRIO_VNESHTORGBANK',
    BANK_MC_BANK_RUS = 'BANK_MC_BANK_RUS',
    BANK_SOLID_BANK = 'BANK_SOLID_BANK',
    BANK_CENTROCREDIT_BANK = 'BANK_CENTROCREDIT_BANK',
    BANK_REALIST_BANK = 'BANK_REALIST_BANK',
    BANK_NK_BANK = 'BANK_NK_BANK',
    BANK_MOSCOW_CITY_BANK = 'BANK_MOSCOW_CITY_BANK',
    BANK_PJSCB_DERZHAVA = 'BANK_PJSCB_DERZHAVA',
    BANK_BANK_IPB = 'BANK_BANK_IPB',
    BANK_INDUSTRIAL_SAVINGS_BANK = 'BANK_INDUSTRIAL_SAVINGS_BANK',
    BANK_RGS_BANK = 'BANK_RGS_BANK',
    BANK_NATIONAL_SETTLEMENT_DEPOSITORY = 'BANK_NATIONAL_SETTLEMENT_DEPOSITORY',
    BANK_ING_BANK_EURASIA = 'BANK_ING_BANK_EURASIA',
    BANK_NATIONAL_STANDARD_BANK = 'BANK_NATIONAL_STANDARD_BANK',
    BANK_JSC_CB_LANTA_BANK = 'BANK_JSC_CB_LANTA_BANK',
    BANK_SME_BANK = 'BANK_SME_BANK',
    BANK_BANK_ROUND = 'BANK_BANK_ROUND',
    BANK_VNESHFINBANK = 'BANK_VNESHFINBANK',
    BANK_INECO = 'BANK_INECO',
    BANK_DRIVE_CLICK_BANK_CETELEM_BANK = 'BANK_DRIVE_CLICK_BANK_CETELEM_BANK',
    BANK_AUTO_FINANCE_BANK = 'BANK_AUTO_FINANCE_BANK',
    BANK_BANK_PTB = 'BANK_BANK_PTB',
    BANK_BAIKALCREDOBANK = 'BANK_BAIKALCREDOBANK',
    BANK_BANK_VOLOGZHANIN = 'BANK_BANK_VOLOGZHANIN',
    BANK_ENISEISK_UNITED_BANK = 'BANK_ENISEISK_UNITED_BANK',
    BANK_WILDBERRIES = 'BANK_WILDBERRIES',
    BANK_HFB = 'BANK_HFB',
    BANK_PERSPEKTIVA = 'BANK_PERSPEKTIVA',
    BANK_ROYAL_CREDIT_BANK = 'BANK_ROYAL_CREDIT_BANK',
    BANK_FFIN_BANK_LLC = 'BANK_FFIN_BANK_LLC',
    BANK_BANK_ELITA = 'BANK_BANK_ELITA',
    BANK_STAVROPOLPROMSTROYBANK = 'BANK_STAVROPOLPROMSTROYBANK',
    BANK_BANK_CHBDR = 'BANK_BANK_CHBDR',
    BANK_DOLINSK = 'BANK_DOLINSK',
    BANK_MOBILE_CARD = 'BANK_MOBILE_CARD',
    BANK_HICE = 'BANK_HICE',
    BANK_OZONBANK = 'BANK_OZONBANK',
    BANK_BANK_PERM = 'BANK_BANK_PERM',
    BANK_ELEKSIR_NCO = 'BANK_ELEKSIR_NCO',
    BANK_ALTAYKAPITALBANK = 'BANK_ALTAYKAPITALBANK',
    BANK_BANK_SIAB = 'BANK_BANK_SIAB',
    BANK_SVOI_BANK = 'BANK_SVOI_BANK',
    BANK_CMRBANK = 'BANK_CMRBANK',
    BANK_PTB = 'BANK_PTB',
    BANK_TOCHKA_BANK = 'BANK_TOCHKA_BANK',
    BANK_PROMSELHOZBANK_LTD = 'BANK_PROMSELHOZBANK_LTD',
    BANK_BANK_ORANGE_LLC = 'BANK_BANK_ORANGE_LLC',
    BANK_YARINTERBANK = 'BANK_YARINTERBANK',
    BANK_RB_FAKTURA = 'BANK_RB_FAKTURA',
    BANK_RSB_RUSSIAN_STANDARD_BANK = 'BANK_RSB_RUSSIAN_STANDARD_BANK',
}
